import styled from "styled-components";

import { SmallButton, WrapperContainer } from "../../../components";
import { ViewOnlyContainer } from "../../../components/ViewOnlyInputValues/styled";

export const ConsentFromWrapper = styled(WrapperContainer)``;

export const ConsentFromLeftSectionWrapper = styled(WrapperContainer)``;

export const ContentDropdownsWrapper = styled(WrapperContainer)``;

export const ButtonsWrapper = styled(WrapperContainer)`
  @media screen and (max-height: 750px) {
    padding-bottom: 32px;
  }
`;

export const FormButton = styled(SmallButton)`
  min-width: 136px;
`;

export const ConsentFormWrapper = styled(WrapperContainer)`
  width: 100%;
  overflow: auto;

  ${ViewOnlyContainer} {
    p {
      max-height: 150px;
    }

    pointer-events: all;
    overflow: auto;
  }
`;

export const ConsentTextEditorWrapper = styled(WrapperContainer)`
  .editor {
    height: 100%;
    min-height: ${(props) => (props.isViewOnly ? "144.8px" : "100px")};
    max-height: ${(props) => (props.isViewOnly ? "20vh" : "calc(20vh - 44.8px)")};
  }
`;
